<template>
<div>
  <b-img fluid class="bkg_img" :src="require('@/assets/images/pages/graphic-1.png')" />
  <div id="newsletter-public">
     <b-card
        class="h-full"
        header-bg-variant="primary" no-body>
        <template #header>
          <span class="text-white text-lg font-bold">{{newsletter.title}}</span>
        </template>
        <b-container fluid class="p-4 bg-primary" v-if="hasNewsletterNotFount">
          <b-row>
            <b-col>
              <b-img center thumbnail fluid :src="require('@/assets/images/pages/404-2.png')" alt="Página 404"></b-img>
            </b-col>
          </b-row>
        </b-container>
        <div class="pt-1 p-1" v-if="hasNewsletter">
          <div class="flex flex-col gap-1">
            <div class="_row">
              <complex-editor-view :editor_data.sync="newsletter.content"/>
              <!-- <div class="simple-content simple-editor editor-content ck-content ml-2 mr-2 unselectable" v-html-safe="newsletter.content? newsletter.content: ''"></div>
               -->
            </div>
            <div class="w-full align-middle gap-2 justify-end">
              <span class="pl-1 text-primary align-middle">
                <feather-icon
                  icon="EyeIcon"
                  class="mr-50">
                </feather-icon>
                  <span class="align-middle">{{countView}} &nbsp; {{$t('newsletter.view')}}</span>
              </span>
              <span class="pl-1 text-primary align-middle">
                <feather-icon
                  icon="MessageCircleIcon"
                  class="mr-50">
                </feather-icon>
                  <span class="align-middle">{{countComments}} &nbsp; {{$t('newsletter.comment')}}</span>
              </span>
            </div>

            <div class="w-full align-middle gap-2 pb-2 justify-start">
              <b-button v-if="alownLike"
                variant="flat-success"
                class="btn-icon"
                @click="likeContent">
                <feather-icon
                  icon="ThumbsUpIcon"
                  class="mr-50"/>
                  <span class="align-middle">{{countLike}} &nbsp; {{$t('action.like')}}</span>
              </b-button>
              <b-button
                variant="flat-warning"
                class="btn-icon"
                @click="signReading"
                v-if="alownSignReading">
                <feather-icon
                  icon="BookOpenIcon"
                  class="mr-50"/>
                  <span class="align-middle">{{$t('action.sign_reading')}}</span>
              </b-button>
            </div>
          </div>
        </div>
        <b-row class="m-0 mb-2" v-if="hasNewsletter && alownComments">
          <b-col
            lg="12">
            <b-form-group
              :label="$t('newsletter.comments.add_comment')"
              label-for="comment">
              <b-form-textarea
                id="comment"
                v-model="comment.content"
                :state="stateComment"
                :placeholder="$t('form_min_caracter_', [10])"
                rows="4"/>
            </b-form-group>
            <div class="w-full flex gap-2 justify-end pb-1">
              <b-button
                variant="primary"
                :disabled="!stateComment"
                @click="saveComment">
                {{ $t('action.send_comment') }}
              </b-button>
            </div>
          </b-col>
        </b-row>
        <comments-include :newsletterId="newsletter.id" :comments="newsletter.comments" :showComments="hasNewsletter && alownComments"></comments-include>
        <template #footer>
          <page-footer :showLoginLink="false"></page-footer>
        </template>
      </b-card>
  </div>

  <b-modal
    v-model="showModalSignReading"
    :title="$t('newsletter.sign_reading')"
    :hide-footer="true"
    no-close-on-backdrop
    no-close-on-esc>
    <div class="vx-row">
      <div class="vx-col w-full">
        <b-form-group
          id="signature_name"
          :label="$t('newsletter.signature_name')"
          label-for="signature_name">
          <b-form-input
            id="signature_name"
            v-model="signature.name"
            name="signature_name"
            :state="nameState"
            class="required"/>
        </b-form-group>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <b-form-group
          id="signature_email"
          :label="$t('newsletter.signature_email')"
          label-for="signature_email">
          <b-form-input
            id="signature_email"
            v-model="signature.email"
            name="signature_email"
            :state="emailState"
            class="required"/>
        </b-form-group>
      </div>
    </div>
    <div class="vx-row" v-if="showLegalEntityList">
      <div class="vx-col w-full">
        <b-form-group
          :label="$t('legal_entities_unit')"
          label-for="legal_entities_unit">
            <v-select
              v-model="selectedLegalEntity"
              :options="legalEntityList"
              label="company_name"
              class="required-select"
              :append-to-body="false"
              :select-on-tab="true"
              :clearable="false">
              <div slot="no-options">{{$t('msg_none')}}</div>
            </v-select>
        </b-form-group>
      </div>
    </div>

    <div class="w-full flex gap-2 justify-end pt-4">
      <b-button variant="primary" @click="saveSignature" :disabled="!enableSaveSignature">
        {{$t('action.signature')}}
      </b-button>
      <b-button variant="outline-secondary" @click="closeModalSignReading">
        {{$t('action.close')}}
      </b-button>
    </div>
  </b-modal>
</div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import {
  BForm,
  BFormGroup,
  BRow,
  BCol,
  BLink,
  BCard,
  BCardText,
  BCardTitle,
  BCardFooter,
  BCardImg,
  BImg,
  BInputGroup,
  BFormInput,
  BFormTextarea,
  BButton,
  BAlert,
  VBTooltip,
  BModal,
} from 'bootstrap-vue'

import NewsletterService from '@/services/api/NewsletterService'
import PageFooter from '@/components/PageFooter.vue'

import CommentsInclude from './CommentsInclude.vue'
import ComplexEditorView from '@/components/ComplexEditorView.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BInputGroup,
    BFormInput,
    BFormTextarea,
    BLink,
    BCard,
    BCardText,
    BCardTitle,
    BCardFooter,
    BCardImg,
    BImg,
    BButton,
    BAlert,
    VBTooltip,
    BModal,
    vSelect,
    MediaList,
    PageFooter,
    CommentsInclude,
    ComplexEditorView,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    link: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      newsletter: {
        id: null,
        title: '',
        link: '',
        content: '',
        data: {
          like: 0
        },
        comments: []
      },
      comment:{
        content: ''
      },
      signature: {
        name: '',
        email: '',
        legal_entity_id: null
      },
      hasNewsletterNotFount: false,
      service: null,
      showModalSignReading: false,
      legalEntityList: [],
      selectedLegalEntity: null,
    }
  },
  watch: {

  },
  computed: {
    hasComments() {
      return (this.newsletter.comments && this.newsletter.comments.length > 0)
    },
    hasNewsletter() {
      return (this.newsletter && this.newsletter.id != null)
    },
    countLike(){
      return _.get(this.newsletter,'data.like', 0)
    },
    countView(){
      return _.get(this.newsletter,'data.view', 0)
    },
    countComments(){
      return _.get(this.newsletter,'comments.length', 0)
    },
    alownLike(){
      return _.get(this.newsletter,'allows_enjoy', false)
    },
    alownComments(){
      return _.get(this.newsletter,'allows_comment', false)
    },
    alownSignReading(){
      return _.get(this.newsletter,'allows_signature', false)
    },
    showLegalEntityList(){
      return _.get(this.newsletter,'legal_entity_id', false)
    },
    nameState() {
      if (this.signature.name.length === 0) return null
      return this.signature.name.length >= 5
    },
    emailState() {
      if (this.signature.email.length === 0) return null
      return this.$utils.validation.email(this.signature.email)
    },
    enableSaveSignature(){
      let enable = this.signature.name.length >= 3 &&
                   this.$utils.validation.email(this.signature.email);
      if(this.showLegalEntityList){
        enable =  enable && this.selectedLegalEntity
      }

      return enable;
    },
    stateComment(){
      if(this.comment.content.length === 0)return null
      return this.comment.content.length >= 10
    },

  },
  methods: {
    getNewsletterByLink(){
      this.$vs.loading()
      this.service.getNewsletterByLink(this.link).then(
          (data) => {
            this.newsletter = data
            this.legalEntityList = data.legal_entity_list ? data.legal_entity_list : []
          },
          (error) => {
            this.$vs.loading.close()
            this.hasNewsletterNotFount = true
          }
        ).finally(() => this.$vs.loading.close())
    },
    saveComment() {
      this.$vs.loading()

      const modelData = {
        content: this.comment.content
      }

      this.service.saveComment(this.link, modelData).then(
        data => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          this.newsletter.comments.push(data)
          this.clearForm()
        },
        error => {
          this.showErrors(this.$validator, error)
          this.notifyError(this.$vs,this.$t('messages.error'))
        }
      ).finally(() => { this.$vs.loading.close() })
    },
    likeContent() {
      this.$vs.loading()

      const modelData = {
        content: this.comment.content
      }

      this.service.likeContent(this.link).then(
        response => {
          this.newsletter.data.like = response.data.like
        },
        error => {
          this.showErrors(this.$validator, error)
          this.notifyError(this.$vs,this.$t('messages.error'))
        }
      ).finally(() => { this.$vs.loading.close() })
    },
    clearForm(){
      this.comment.content = ''
    },
    formatTime(time) {
      const thenEpoch = (new Date(time)).getTime()
      return this.readableHumanTime(thenEpoch)
    },
    signReading() {
      this.showModalSignReading = true
    },
    saveSignature() {
      this.$vs.loading()

      const modelData = {
        name: this.signature.name,
        email: this.signature.email,
        legal_entity_id: this.selectedLegalEntity ? this.selectedLegalEntity.id : null
      }

      this.service.addSignature(this.link, modelData).then(
        response => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          this.clearSignature()
          this.showModalSignReading = false
        },
        error => {
          this.showErrors(this.$validator, error)
          this.notifyError(this.$vs,this.$t('messages.error'))
        }
      ).finally(() => { this.$vs.loading.close() })
    },
    closeModalSignReading() {
      this.showModalSignReading = false
    },
    clearSignature() {
      this.signature.name = ''
      this.signature.email = ''
      this.signature.legal_entity_id = null
      this.selectedLegalEntity = null
    }
  },
  mounted() {
    this.getNewsletterByLink()

  },
  beforeMount() {
    this.$vs.loading()
    const promisses = []

    //Service
    this.service = NewsletterService.build(this.$vs)

    Promise.all(promisses).then(() => {
      this.$vs.loading.close()
    })
  },
}
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/simple-content.scss';

.bkg_img {
  position: fixed;
  scale: 1.2;

  right: 0;
  bottom: 0;
}
#newsletter-public {
  @apply top-0 bottom-0 right-0 left-0;
  // position: absolute;
  padding: 1% 1%;
  padding-top: 3rem !important;
  @screen sm {
    padding: 1% 5%;
  };
  @screen lg {
    padding: 3% 18%;
  }
  & > .card {
    min-height: 50vh !important;

    & ._row {
      width: 100%;
    }

    & > .card-header {
      padding: 0.5rem 1.5rem;
    }
  }

  & table.b-table {
    & th, td {
      padding: 1px;
      @screen sm {
        padding: 0.72rem 2rem;
      }
    }
  }

  & .card-footer {
    padding: 0.5rem;
    @screen sm {
      padding: 1.5rem;
    }
  }
}

// Fix v-select dropdown inside modal
.modal-body {
  .v-select {
    .vs__dropdown-menu {
      max-height: 250px;
      overflow-y: auto;
      z-index: 9999;
    }
  }
}

</style>

